<template>
    <el-container>
        <el-header height="88px">
            <HeaderNav :curHash="'product'" @updateLang='updateLang' />
        </el-header>
        <el-main :style="`height:${contentHeight}; flex-grow:1; padding: 0`">
            <!-- <img src="../assets/images/product.jpg" alt=""> -->
            <img src="" class="product-img" alt="">
            <el-card class="">
                <div class="torvandom-product-container">
                    <div slot="header" class="clearfix card-header">
                        <span class="card-type">{{$t('productTitle')}}</span>
                    </div>
                    <div v-for="(item, index) in productList" :key="index" class="item-repeat">
                        <p class="type">{{item.type}}</p>
                    </div>
                </div>
            </el-card>
        </el-main>
        <el-footer height="54px">
            <Footer ref="foot-ref" />
        </el-footer>
    </el-container>
</template>

<script>
import HeaderNav from '../components/header.vue'
import Footer from '../components/footer.vue'
import { getProductList } from '../../static/data.js'
export default {
  name: 'Product',
  components: { HeaderNav, Footer },
  data () {
    return {
      contentHeight: 0,
      productList: [],
      lang: ''
    }
  },
  methods: {
      updateLang (val) {
          this.lang = val
      },
      getContextByLang (lang) {
          this.productList = getProductList(lang)
          this.$refs['foot-ref'].switchLang(lang)
      }
  },
  watch: {
      'lang' (val, old) {
          if (val && old) {
            this.getContextByLang(val)
          }
      }
  },
  mounted () {
      this.lang = this._i18n._vm.locale
      this.getContextByLang(this.lang)
      this.$nextTick(() => {
          this.contentHeight = document.documentElement.clientHeight - 54 - 88 + 'px'
      })
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.el-card.is-always-shadow{
    box-shadow: none;
    border: none
}
.product-img{
    min-height: 371px;
    width: 100%;
    background: rgba(153, 154, 153, 0.1)
}
.torvandom-product-container{
    width: 80%;
    margin: auto;
    .card-header{
        text-align: left;
        margin: 20px 0;
        font-size: 24px;
        font-weight: bold;
    }
    .item-repeat{
        text-align: left;
        margin-left: 100px;
        line-height: 32px;
        font-family: '-webkit-pictograph';
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/product.vue